export default __webpack_public_path__ + "static/media/plus-circle-white.892709a0.svg";